import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finance-menu',
  templateUrl: './finance-menu.component.html',
  styleUrls: ['./finance-menu.component.css']
})
export class FinanceMenuComponent implements OnInit {
  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Finance')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/finance-menu/finance-menu.component.ts